// extracted by mini-css-extract-plugin
module.exports = {"Toggler":"SideDrawerToggler_Toggler__1R0_g","TogglerNotTranslated":"SideDrawerToggler_TogglerNotTranslated__fJAbK","TogglerTranslated":"SideDrawerToggler_TogglerTranslated__1_DDq"};